import React, { Component }          from "react";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import { Button, Modal }             from "react-bootstrap";
import LoaderButton                  from "../../components/LoaderButton";
import { Colors }                    from "../../utils/Colors";
import { invokeCreateProgramFolder } from "../../utils/AwsInvoke";
import YouTubePlayer                 from "../../components/YouTubePlayer";
import "../../css/modal/ModalAlert.css";
import "../../css/modal/ModalBasics.css";

export default class ModalHelpYouTube extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalAlert: false,
            isLoading: false,
        };
    }

    /*handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.setState({ showModalAlert: false });
        }
    }*/

    componentDidMount() {
        this.setState({
            showModalAlert: this.props.showModalAlert,
            alertObject:    this.props.alertObject,
            isLoading: false
            //alertFunction:    this.props.alertFunction,
        });
    }

    componentDidUpdate(nextProps, prevState){
        if(nextProps.showModalAlert !== prevState.showModalAlert){
            this.setState ({
                showModalAlert: nextProps.showModalAlert
            });
        }
    }

    handleCloseWin = (action) => {
        this.setState({
            isLoading: true,
        });
        var alert_action = this.props.alertAction;

        if(action === "delete" && action != "close") {
            var alertObject  = this.props.alertObject;

            var client_id    = alertObject.client_id;
            var program_id   = alertObject.program_id;
            var folder_id    = alertObject.folder_id;

            this.props.alertFunction(alert_action, client_id, program_id, folder_id);
        } else {
            this.setState({ showModalAlert: false, isLoading: false });
            this.props.onHide();
        }
    }

    createMarkup(html) { return {__html: html}; };

    render() {
        var message_body  = this.props.messageBody;
        var message_title = this.props.messageTitle;
        var alert_action  = this.props.alertAction;
        var button_color  = "#408fd2";

        var buttons = <span>
                            <Button className="modalBasicsBtnOk" onClick={() => this.handleCloseWin("ok")}>OK</Button>
                      </span>

        // button colors: https://react-bootstrap.github.io/components/buttons/
        if(alert_action === "deleteProgram" || alert_action === "deleteFolder") {
                button_color  = Colors.delete_button_dark_red_bg; // lighter version: #ff4444
                buttons = <span>
                                <Button className="modalBasicsBtnClose" onClick={() => this.handleCloseWin("close")}>Cancel</Button>
                                <span className="modalBasicsFooterXPosSpacer"/>
                                { /*}<Button className="modalButtonOk" bsStyle="primary" onClick={() => this.handleCloseWin("delete")}>Ok</Button>*/ }
                                <LoaderButton
                                    bsSize    = "large"
                                    //disabled  = {!this.validateForm()}
                                    //type      = "submit"
                                    btncolor  = { button_color }
                                    height    = {38}
                                    width     = {130}
                                    isLoading = {this.state.isLoading}
                                    text        = "Yes, Delete"
                                    loadingText = ""
                                    onClick     = {() => this.handleCloseWin("delete")}
                                  />
                          </span>
        }

        return (
            <div>
                  <Modal
                         show            = {this.state.showModalAlert}
                         onHide          = {() => this.handleCloseWin("close")}
                         aria-labelledby = "contained-modal-title"
                         size            = "lg"
                         centered        = "true"
                         className       = "modalBasics"
                       >
                         <Modal.Header>
                             <Modal.Title id="contained-modal-title">
                                    <FontAwesomeIcon icon="info-circle" className="modalAlertIcon" />
                                    <span className="modalBasicsTitle">
                                        { message_title }
                                    </span>
                             </Modal.Title>
                         </Modal.Header>

                         <Modal.Body>
                           <div style={{width:"570px", height:"280px", backgroundColor:"#ccc"}}>
                               <span style={{position:"relative", top:"20px", left: "20px"}}></span>
                               <YouTubePlayer yt_id={"jeRQzVJ9_DM"} />
                           </div>

                         </Modal.Body>

                         <Modal.Footer>
                             {buttons}
                         </Modal.Footer>
                   </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalHelpYouTube.js